import { SchedulerSidebarData } from './types';

export const initialState: SchedulerSidebarData = {
  crewMembers: [],
  equipmentMembers: [],
  disabled: false,
  defaultCrew: true,
  defaultCrewChanged: false,
  defaultEquipment: true,
  defaultEquipmentChanged: false,
  populateDefaultCrewAndEquipment: false,
  currentSchedule: {
    id: '',
    startsAt: '',
    endsAt: '',
    foreman: {
      id: '',
      firstName: '',
      lastName: '',
      email: '',
      specialties: [],
    },
    defaultCrew: false,
    defaultCrewChanged: false,
    defaultEquipment: false,
    defaultEquipmentChanged: false,
    status: '',
    scheduleMembers: [],
    scheduleAssets: [],
    task: {
      id: '',
      note: {
        id: '',
        content: '',
      },
      requirements: [
        {
          id: 'new',
          currentlyAssigned: 0,
          totalNeeded: 0,
          requirementType: 'crew_member',
        },
      ],
    },
  },
  confirm: {
    crewAssignment: {
      open: false,
      keepCurrentCrew: true,
    },
    crewChanged: {
      open: false,
      keep: true,
    },
    equipmentAssignment: {
      open: false,
      keepCurrentEquipment: true,
    },
    equipmentChanged: {
      open: false,
      keep: true,
    },
  },
  crewChangeScope: 'currentOnly',
  relatedMultischedules: undefined,
  plannedDays: 1,
  extensionDates: [],
};
